import { render, staticRenderFns } from "./shopProductPage.vue?vue&type=template&id=dcc97006&scoped=true"
import script from "./shopProductPage.vue?vue&type=script&lang=js"
export * from "./shopProductPage.vue?vue&type=script&lang=js"
import style0 from "./shopProductPage.vue?vue&type=style&index=0&id=dcc97006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc97006",
  null
  
)

export default component.exports